'use strict';

var d3 = require('d3');
var _ = require('lodash');
var ChartFBCApplicabilityScalesFactory = function ChartFBCApplicabilityScalesFactory(chartFbcApplicabilityYAxisService) {
  var barHeight = 30;
  var Scales = function Scales(params, data, xAxisValues) {
    barHeight = params.height * params.beltPartHeight || barHeight;
    var values = [];
    var yDomain;
    var yRange;
    var yMin = d3.min(data, function (d) {
      return d3.min(d.fares, function (fare) {
        values.push(fare.fareValue);
        return fare.fareValue;
      });
    });
    values = _.uniq(values);
    values.sort(function (a, b) {
      return a - b;
    });
    var yMax = d3.max(data, function (d) {
      return d3.max(d.fares, function (fare) {
        return fare.fareValue;
      });
    });
    var range = yMax - yMin;
    var barPartHeight = barHeight / (params.height - barHeight);
    var removeEmptySpace = chartFbcApplicabilityYAxisService.isBarsInPile(values, barPartHeight, range);
    if (values.length === 1) {
      yDomain = [0, yMax];
      yRange = [params.height, 0];
    } else if (removeEmptySpace) {
      var yScaleConf = chartFbcApplicabilityYAxisService.createYConfigWithEmptySpace(values, range, params.height, yMin, yMax, barHeight);
      yDomain = yScaleConf.domain;
      yRange = yScaleConf.range;
    } else {
      yDomain = [yMin - barPartHeight * range, yMax];
      yRange = [params.height, 0];
    }
    var dates = xAxisValues;
    var x = d3.scale.ordinal().domain(dates).rangeBands([0, params.width], 0, 0);
    var y = d3.scale.linear().domain(yDomain).rangeRound(yRange);
    return {
      xScale: x,
      yScale: y
    };
  };
  return Scales;
};
ChartFBCApplicabilityScalesFactory.$inject = ['ChartFbcApplicabilityYAxisService'];
module.exports = ChartFBCApplicabilityScalesFactory;